export default __webpack_public_path__ + "static/covid-press-Telangana Today-0095c772e97b01a0a490d3ce416fc1cd.png";